import {
  ConfigApi,
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';

type Options = {
  discoveryApi: DiscoveryApi;
  configApi: ConfigApi;
  fetchApi: FetchApi;
};

export const googleApi = createApiRef<GoogleApi>({
  id: 'plugin.google.service',
});

export class GoogleApi {
  private readonly backendUrl: string | undefined;
  private readonly fetchApi: FetchApi;
  private readonly confApi: ConfigApi;


  constructor(options: Options) {
    this.backendUrl = options.configApi.getOptionalString('backend.baseUrl');
    this.fetchApi = options.fetchApi;
    this.confApi = options.configApi;
  }

  private getBaseUrl() {
    return `${this.backendUrl}/api/google`;
  }

  /**
   * Get diff statistics for a pull request
   */
  async getSpreadsheets(params: { spreadsheetId?: string; }): Promise<any> {
    const { spreadsheetId } = params;
    const baseUrl = this.getBaseUrl();
    const configSheetId = this.confApi.getOptionalString('integrations.sev2.feedbackSheetId');
    const defaultSheetId = '1a2lUG5lBJ6pfXQWOTwdvyhetiNbxilnuZQoXoBz9QHo';
    const sheetId = spreadsheetId || configSheetId || defaultSheetId;

    const response = await this.fetchApi.fetch(`${baseUrl}/spreadsheets/${sheetId}`, {
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch spreadsheets: ${response.statusText}`);
    }

    return response.json();
  }

  async getSpreadsheetsValue(params: { spreadsheetId?: string; range?: string }): Promise<any> {
    const { spreadsheetId, range } = params;
    const baseUrl = this.getBaseUrl();
    const configSheetId = this.confApi.getOptionalString('integrations.sev2.feedbackSheetId');
    const defaultSheetId = '1a2lUG5lBJ6pfXQWOTwdvyhetiNbxilnuZQoXoBz9QHo';
    const sheetId = spreadsheetId || configSheetId || defaultSheetId;

    const response = await this.fetchApi.fetch(`${baseUrl}/spreadsheets/${sheetId}/values/${range}`, {
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch spreadsheets value: ${response.statusText}`);
    }

    return response.json();
  }
}
